import { useToggleMbtcMutation } from '~/client/hooks/currency/useToggleMbtc/ToggleMbtcMutation.generated';
import { useUpdateMyDefaultCurrencyMutation } from '~/shared/graphql/UpdateMyDefaultCurrencyMutation.generated';

const useHandleSportsbetRegister = () => {
  const [updateMyCurrency] = useUpdateMyDefaultCurrencyMutation();
  const [toggleMbtcMutation] = useToggleMbtcMutation();

  const handleSportsbetRegister = async () => {
    await updateMyCurrency({ variables: { currency: 'BTC' } });
    await toggleMbtcMutation({ variables: { mBTC: true } });
  };

  return { handleSportsbetRegister };
};

export default useHandleSportsbetRegister;
